export function checkParticipantsUserRole(
  participants,
  role1,
  userId1,
  role2,
  userId2
) {
  const hasRole1UserId1 = participants.some(
    (p) => p.role === role1 && p.userId === userId1
  );
  const hasRole2UserId2 = participants.some(
    (p) => p.role === role2 && p.userId === userId2
  );
  return hasRole1UserId1 && hasRole2UserId2;
}
